var exports = {
  "uL": "PopoutTitlebar.module__titlebar___dDhxSn",
  "pY": "PopoutTitlebar.module__titlebarMac___dDhxSn",
  "DD": "PopoutTitlebar.module__title___dDhxSn",
  "o1": "PopoutTitlebar.module__actions___dDhxSn",
  "bR": "PopoutTitlebar.module__actionButtonActive___dDhxSn",
};

module.exports = exports;
